import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasicTreeIconComponent } from './basic-tree-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
    ],
    declarations: [
        BasicTreeIconComponent,
    ],
    exports: [
        BasicTreeIconComponent,
    ],
})
export class BasicTreeIconModule {}
